import type { W_Material_CreateBulk_RM, W_Material_CreateBulk_RM_Single } from 'ab-api/web/material/createBulk';

import type { CSVRow, CSVData } from 'ab-viewModels/csv.viewModel';

import { PlainUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

function parseRow(row: CSVRow): W_Material_CreateBulk_RM_Single {
	const unit = row.unit === 'LF' ? PlainUnitEnum.LFT : row.unit;

	return {
		group1: row.group1,
		group2: row.group2,
		group3: row.group3,
		tags: row.tags.split(',').filter((tag) => !!tag?.length),
		vendor: !!row.vendor ? row.vendor : null,
		vendorUniqueId: row.vendorId.length > 0 ? row.vendorId : null,
		displayName: row.displayName,
		description: row.description,
		unit: unit === 'LF' ? PlainUnitEnum.LFT : unit as PlainUnitEnum, // cast is deliberate, the BE will validate and report on the issue
		baseCost: +row.baseCost,
		shippingMarkup: row.shipping ? +row.shipping : null,
		salesMarkup: row.salesMarkup ? +row.salesMarkup : null,
		tax: row.tax ? +row.tax : null,
	};
}

export const parse = (data: CSVData): W_Material_CreateBulk_RM => {
	return { materials: data.map(parseRow) };
};
